<template>
  <FormulateForm class="mc-basic-info-request" v-model="formValues">
    <h4 class="mc-basic-info-request__title card-title">{{ $t('deliveryRequest.detail.sectionTitle') }}</h4>

    <div class="card">
      <div class="card-body">
        <b-row>
          <b-col cols="12" xl="6">
            <FleetTaskReadOnly
              class="mc-basic-info-request__read-only"
              :showResponse="showResponse"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </FormulateForm>
</template>

<script>
import FleetTaskReadOnly from '../ReadOnly/FleetTaskReadOnly'
import moment from 'moment'

moment.locale('id')

export default {
  components: {
    FleetTaskReadOnly,
  },
  props: {
    showResponse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formValues: {},
    }
  },
}
</script>

<style lang="scss" scoped>
.mc-basic-info-request {
  &__title {
    margin-bottom: 12px;
  }

  &__read-only {
    margin-bottom: 24px;
  }

  &__toggle {
    margin: 20px 0;
  }

  hr {
    margin: 24px 0;
  }
}
</style>
